import DiscountsModule from "./DiscountsModule";
import reducer from "./redux/discountsReducer";
import rootSaga from "./redux/discountsSagas";

export default {
  Component: DiscountsModule,
  moduleName: "discounts",
  saga: rootSaga(),
  reducer: reducer
};
